import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { CampaignClass } from '@feathr/blackbox';
import { CampaignLabelMap } from '@feathr/blackbox';
import { Pill } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

import { campaignColorMap } from '../../styles/campaign';
import { getCampaignIcon } from '../CampaignIcons';

interface IProps {
  className?: string;
  cls: CampaignClass;
  name?: string;
  /** Whether or not the campaign is for monetization. Default is false */
  isMonetization?: boolean;
}

function CampaignTypeChip({
  className,
  cls,
  name,
  isMonetization = false,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Pill
      className={className}
      name={name ?? 'campaign-type-chip'}
      prefix={getCampaignIcon(cls)}
      suffix={isMonetization && getIconForAction('monetization')}
      theme={campaignColorMap.get(cls)}
    >
      {CampaignLabelMap.get(cls) ?? t('Campaign')}
    </Pill>
  );
}

export default CampaignTypeChip;
